import api from '../httpClient';

export interface DrvPrimaryType {
  id: string;
  source: string;
  sheetName: string;
  nutrientId: string; // e.g., "vitamin_a"
  nutrientLabel: string; // e.g., "Vitamin A"
  primaryType: string; // e.g., "RDA", "AI"
  primaryField: string | null; // e.g., "rda", "ai", or null
  primaryRawType: string;
  sampleCount: number;
  hasTypeConflict: boolean;
  updatedAt: string;
}

export interface GetDrvPrimaryTypesParams {
  source?: string;
  limit?: number;
  page?: number;
}

export interface GetDrvPrimaryTypesResponse {
  items: DrvPrimaryType[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export const getDrvPrimaryTypes = async (params: GetDrvPrimaryTypesParams = {}): Promise<GetDrvPrimaryTypesResponse> => {
  const queryParams = new URLSearchParams();
  
  if (params.source) queryParams.append('source', params.source);
  if (params.limit) queryParams.append('limit', params.limit.toString());
  if (params.page) queryParams.append('page', params.page.toString());

  const response = await api.get(`/drv/primary-types?${queryParams.toString()}`);
  return response.data;
};

export interface CalculateDrvRequirementsParams {
  dateOfBirth: string;
  gender: string;
  eer: number;
  weightKg: number;
  sexAtBirth?: string;
  pregnancyTrimester?: string;
  lactationPeriod?: string;
  countryCode?: string;
  drvGuidelineId?: string;
  drvFormulaId?: string;
  drvSource?: string;
}

export const calculateDrvRequirements = async (params: CalculateDrvRequirementsParams) => {
  const response = await api.post('/calculations/drv-requirements', params);
  return response.data;
};
